import React, { useEffect, useState } from 'react';
import { FileMetadata } from '../types';
import { listFiles } from '../api';

const FileList: React.FC = () => {
    const [files, setFiles] = useState<FileMetadata[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const loadFiles = async () => {
            try {
                // Provide all required arguments for listFiles
                const fetchedFiles = await listFiles('/some/path', '', 1, 50, false);
                setFiles(fetchedFiles);
            } catch (err) {
                setError('Failed to load files');
            } finally {
                setLoading(false);
            }
        };

        loadFiles();
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <div>
            <h2>File List</h2>
            <ul>
                {Array.isArray(files) ? files.map(file => (
                    <li key={file.name}>
                        <span>{file.name}</span>
                        <button onClick={() => downloadFile(file)}>Download</button>
                    </li>
                )) : null}
            </ul>
        </div>
    );

    function downloadFile(file: FileMetadata) {
        // Implement download functionality here
    }
};

export default FileList;